module.exports = __webpack_public_path__ + "img/tops-col.195c3cc7.png";